import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hover-right",
  "use": "icon-hover-right-usage",
  "viewBox": "0 0 7 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 7 12\" id=\"icon-hover-right\">\r\n<style type=\"text/css\">\r\n\t#icon-hover-right .st0{fill:'';}\r\n</style>\r\n<path class=\"st0\" d=\"M1,11.5c-0.1,0-0.3,0-0.4-0.1c-0.2-0.2-0.2-0.5,0-0.7L5.3,6L0.6,1.4c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l5,5\r\n\tc0.2,0.2,0.2,0.5,0,0.7l-5,5C1.3,11.5,1.1,11.5,1,11.5z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol